
import { Component, Vue } from "vue-property-decorator";

interface TrafikForm {
  cezaTuru: string | null;
  aracHizi: number | null;
  hizLimiti: number | null;
  promil: number | null;
  aracTuru: string | null;
  tekrarSayisi: number | null;
}

interface TrafikResponse {
  ceza_tutari: number;
  aciklama: string;
}

@Component
export default class TrafikCezasiHesaplayici extends Vue {
  form: TrafikForm = {
    cezaTuru: null,
    aracHizi: null,
    hizLimiti: null,
    promil: null,
    aracTuru: null,
    tekrarSayisi: null,
  };
  sonuc: TrafikResponse | null = null;
  yukleniyor: boolean = false;
  genelHataMesaji: string | null = null;

  cezaTurleri = [
    { deger: "kirmizi_isik", metin: "Kırmızı Işık İhlali" },
    { deger: "hiz_ihlali", metin: "Hız Sınırı İhlali" },
    { deger: "alkollu_arac", metin: "Alkollü Araç Kullanma" },
    { deger: "cep_telefonu", metin: "Cep Telefonu Kullanma" },
    { deger: "emniyet_kemeri", metin: "Emniyet Kemeri Takmama" },
  ];

  aracTurleri = [
    { deger: "otomobil", metin: "Otomobil" },
    { deger: "ticari", metin: "Ticari" },
    { deger: "diger", metin: "Diğer" },
  ];

  get formGecerli(): boolean {
    if (!this.form.cezaTuru) return false;

    if (this.form.cezaTuru === "hiz_ihlali") {
      return (
          this.form.aracHizi !== null &&
          this.form.aracHizi >= 0 &&
          this.form.hizLimiti !== null &&
          this.form.hizLimiti > 0
      );
    }

    if (this.form.cezaTuru === "alkollu_arac") {
      return (
          this.form.promil !== null &&
          this.form.promil >= 0 &&
          !!this.form.aracTuru &&
          this.form.tekrarSayisi !== null &&
          this.form.tekrarSayisi >= 1
      );
    }
    return true;
  }

  // TL format
  tlFormat(sayi: number | null | undefined): string {
    if (sayi === null || sayi === undefined) return "";
    return sayi.toLocaleString("tr-TR", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
  }

  handleApiError(error: any) {
    if (error && error.response && error.response.data) {
      const data = error.response.data;
      if (data.errors) {
        const messages = Object.values(data.errors).flat();
        if (messages.length > 0) {
          this.genelHataMesaji = messages.join('\n');
          return;
        }
      }
      if (typeof data === "string") {
        this.genelHataMesaji = data;
      } else if (data.message) {
        this.genelHataMesaji = data.message;
      } else {
        this.genelHataMesaji = "Beklenmeyen bir hata oluştu.";
      }
    } else {
      this.genelHataMesaji = "Sunucuya ulaşılamadı.";
    }
  }

  async hesapla() {
    if (!this.formGecerli) return;
    this.yukleniyor = true;
    this.sonuc = null;
    this.genelHataMesaji = null;

    try {
      const response = await (this as any).$http.post(
          "/api/v1/hesaplayicilar/trafik-cezasi",
          {
            ceza_turu: this.form.cezaTuru,
            arac_hizi: this.form.aracHizi,
            hiz_limiti: this.form.hizLimiti,
            promil: this.form.promil,
            arac_turu: this.form.aracTuru,
            tekrar_sayisi: this.form.tekrarSayisi,
          }
      );
      const data = response.data || response;
      this.sonuc = data;

    } catch (e) {
      this.handleApiError(e);
    } finally {
      this.yukleniyor = false;
    }
  }
}
